const STRINGS = {
  acceptAllHours: 'Accept all hours',
  acceptFrom: 'Accept from',
  acceptFutureDates: 'Accept future dates',
  acceptFutureDatesTime: 'Accept future dates and time',
  acceptFutureDatesTimeTooltip:
    'When "Accept future dates and time" toggle is on, participants will be able to select future dates/time from their current date/time if it is within the acceptable configured range.',
  acceptFutureDatesTooltip:
    'When "Accept future dates" toggle is on, participants will be able to select future dates/time from their current date/time if it is within the acceptable configured range.',
  acceptFutureTime: 'Accept future time',
  acceptFutureTimeTooltip:
    'When "Accept future time" toggle is on, participants will be able to select future times from their current time if it is within the acceptable time range.',
  acceptTo: 'Accept to',
  accountDeletion: 'Account Deletion',
  accountDeletionDesc:
    'When the account is deleted, data collection is paused for the particiant, and the participant will not be able to log in. The data for this participant will not be deleted.',
  accountDisabled: 'Account disabled',
  accountDisabledDesc:
    'When the account is disabled, data collection is paused for the participant, and the participant will not be able to log in. The data for this participant will not be deleted.',
  accountDisabledDescForCaregiver:
    'When the account is disabled, data collection is paused for the caregiver, and the caregiver will not be able to log in. The data for this caregiver will not be deleted.',
  accountEnabled: 'Account enabled',
  accountLogin: 'Account Login',
  accountSettings: 'Account settings',
  accountSettingsCap: 'Account Settings',
  accountSettingsDesc:
    "Is the meeting is actively happening now, or is the participant ready to login to their device? If yes, you may communicate this temporary password now to assist with the participant's first login process.",
  accountSettingsTitle: 'Speaking with the participant now?',
  history: 'History',
  actualVisitDate: 'Actual visit date',
  actualVisitTime: 'Actual visit time',
  missedVisitReason: 'Missed visit reason',
  addendumForPrefix: 'Addendum for',
  addendumDescription:
    'Addendum is a supplementary to an existing consent. A new addendum will not replace a consent form.',
  addWindow: 'add window',
  adhocVisitDel: 'Adhoc Visit deleted successfully',
  advancedFeatures: 'Advanced features',
  after: 'after',
  afterCompletionOfVisit: 'after completion of visit.',
  afterInstrumentDeployment: 'after instrument deployment day',
  afterReceiptOfArticle: 'after receipt of item.',
  allAudioFiles: 'All Audio Files',
  allFutureDates: 'All future dates',
  allFutureDatesTime: 'All future dates and time',
  allow: 'Allow',
  allowPtps: 'Allow participants',
  allPastDates: 'All past dates',
  allPastDatesTime: 'All past dates and time',
  allStudies: 'All Studies',
  appDisplayName: 'App Display Name',
  appScreening: 'Screening',
  appDisplayNameErr: 'App display name cannot be empty',
  appScreeningErr: 'Screening name cannot be empty',
  at: 'at',
  audioFiles: 'Audio Files',
  avatarItems: 'Avatar Items',
  back: 'Back',
  before: 'before',
  beforeInstrumentDeployment: 'before instrument deployment day',
  cancel: 'Cancel',
  cannotBeEmpty: 'Cannot be empty',
  caseManagement: 'Case management',
  cases: 'Cases',
  celebratory: 'Celebratory',
  clinicianReportedOutcomes: 'Clinician Reported Outcomes',
  clinro: 'ClinRO',
  clinroConfigBody:
    'Invite Clinicians to your study to administer clinician-reported outcome assessments. Manage Clinicians from different sites and assign site-specific surveys for each of them',
  close: 'Close',
  communication: 'Communication',
  compliance: 'Compliance',
  configuration: 'Configuration',
  confirmAndRejectRequest: 'Confirm and reject request',
  consentContent: 'Consent content',
  consentPdfFormatPreview: 'Page format preview',
  consentPdfPageConsentContent: 'CONSENT CONTENT HERE',
  consentPdfPagePlaceholderFooterOne: 'FOOTER 1',
  consentPdfPagePlaceholderFooterTwo: 'FOOTER 2',
  consentPdfPagePlaceholderHeaderOne: 'HEADER 1',
  consentPdfPagePlaceholderHeaderThree: 'HEADER 3',
  consentPdfPagePlaceholderHeaderTwo: 'HEADER 2',
  consentPdfPlaceholderPageNumber: '1/21',
  consents: 'Consents',
  createStudy: 'Create Study',
  createStudyAddPaymentAcct: 'Add Payment Account',
  createStudyManagePayments: 'Or, manage payments yourself',
  createStudyPaymentsManaged: 'Payments will be handled and managed by you',
  createStudyPaymentCurrency: 'Payment currency',
  createStudySelectCurrency: 'Select a currency',
  customOnboarding: 'Custom onboarding',
  customReportButton: 'Custom report button',
  dataCorrection: 'Data Correction',
  datacubedInsights: 'Datacubed Insights',
  dataSync: 'Data Sync Indicator',
  dataSyncConfigBody:
    'When a participant completes an instrument, should a data sync toast appear at the bottom of the screen to show the status of the data transfer?',
  day: 'day',
  days: 'days',
  delete: 'Delete',
  deleteAdhocVisit: 'Delete Adhoc Visit',
  deleteAdhocVisitConfirm: 'Are you sure you want to delete this adhoc visit? This cannot be undone.',
  deleteVisit: 'Delete Visit',
  deleteArm: 'Delete Arm',
  deleteVisitConfirm: 'Are you sure you want to delete this visit? This cannot be undone.',
  deleteArmConfirm:
    'Are you sure you want to delete this arm? All visits associated with this arm will be removed too. This action cannot be undone.',
  diaryTimedEntry: 'How many days after diary deployment should participants be allowed to complete diary entries?',
  instrumentTimedEntry:
    'How many days after instrument deployment should participants be allowed to complete instrument entries?',
  didVisitHappen: 'Did this visit happen?',
  disable: 'Disable',
  disableAccount: 'Disable Account',
  disableAccountDesc: 'Disabling this account will force log out the participant from the app.',
  displayEndOfStudy: 'Display end of study summary',
  document: 'Document',
  documentName: 'Document Name',
  download: 'Download',
  downloadAllAudioFiles: 'Download All Audio Files',
  eConsent: 'eConsent',
  eConsentConfigBody:
    'Deploy eConsent in your study to electronically manage the consent process and facilitate seamless user participation',
  emaillessPCI: 'Participant Contact Information',
  emaillessPCIBody:
    "Participant email address or phone number is not collected on DCH platform by default.<br />Participant's initial account setup and account recovery will need to be completed through an offline authentication process. ",
  emaillessPCINote:
    "Please note: When email collection and/or phone number collection is enabled, participant's contact information will be visible to all admin users through DCH platform.",
  emaillessPCIOpt1: 'Continue without collecting any participant contact information.',
  emaillessPCIOpt2: 'Collect participant email address on DCH.',
  enable: 'Enable',
  enableAccount: 'Enable Account',
  enableAccountDesc: 'Enabling this account will allow participants to log in again.',
  endOfStudyConfigBody:
    'At the end of the study journey, participants can get a full summary of their participation, including number of chapters completed, number of activities completed, and avatar items unlocked',
  endOfStudySummary: 'End of Study Summary',
  enterHere: 'Enter here...',
  errPleaseASelectDiffDeployNoVisits: 'Please select a deployment option other than "Triggered by Visit"',
  errSomeSchedulesTriggeredByVisitNeedEdit: 'Some schedules triggered by visit need to be edited',
  expire: 'Expire',
  expireOffset: 'Expiry Offset',
  features: 'Features',
  foodNutritionalReview: 'Show Nutritional value review',
  foodNutritionalReviewPopup:
    'Activate "Nutritional Insights" to enable participants to view detailed nutritional information for each food entry and Review screen.',
  generateTemporaryPassword: 'Generate Temporary Password',
  geofenceInstruments: 'Geofence-triggered instruments',
  geofences: 'Geofences',
  giftcardConfig: 'Gift card configurations',
  hide: 'Hide',
  inactive_desc: 'We noticed you’ve been inactive. For your security, you will be locked out in [##] seconds.',
  inactive_locked:
    'Due to inactivity, your session has been locked. Please enter your password to pick up where you left off.',
  inactive_pw: 'Please enter your password',
  inactive_return: "I'm Still Here!",
  inactive_title: 'Are you still there?',
  incentives: 'Incentives',
  insightsDashboardUnavailable: 'Datacubed insights dashboard unavailable.',
  invalidIdFormat: 'Invalid ID.',
  invalidIdFormatMessage: 'Please follow the format: {format}',
  instrumentCompletionOrder: 'Instrument Completion Order',
  instrumentDeployedDay: 'Day when the instrument is deployed',
  instrumentOrder: 'Instrument Order',
  instruments: 'Instruments',
  instrumentMaxSiblings: 'You can only display up to {count} questions on a page',
  instrumentMaxSiblingsTooltip:
    'Questions displayed on the same page function as other questions would. Scoring and logic will work the same.',
  languages: 'Languages',
  lastLogin: 'Last login: ',
  loseUnsavedContent: 'Closing out would lose any unsaved content.',
  medicationAdherence: 'Medication Adherence',
  medicationAdherenceConfigBody:
    "Monitor participants' medication adherence by setting up a tracker and increase compliance rates by reminding participants to take their prescribed medications at the correct times",
  midtermRewards: 'Mid-term Rewards',
  midtermRewardsBody:
    'If on, a second currency called “Super Gems” will be introduced to participants, with which they will be able to unlock special rewards like minigames, gift cards and the option to donate to a charity you select.',
  midtermRewardsSubheading:
    'When a participant reaches the end of a mid-term interval, what kind of reward should they receive?',
  neutral: 'Neutral',
  neverExpire: 'Never Expire',
  next: 'Next',
  nextVisitDate: 'Next Visit Date',
  no: 'No',
  noDocuments: 'There are no documents at this time',
  notifications: 'Notifications',
  noTrainingDocument: 'No training document is uploaded at this time',
  noTrainingVideo: 'No training video is uploaded at this time',
  ofRecipientLocalTime: "of recipient's local time.",
  orAttach: 'Or attach by URL',
  ordered: 'Ordered',
  orderedInstrumentsBody:
    'If a participant has more than 1 activity at a given time, there is a specific order in which surveys need to be completed',
  orderedInstrumentsHeading: 'Ordered Instruments',
  participant: 'Participant',
  participantCurrentDate: 'Participant current date',
  participantCurrentTime: 'Participant current time',
  participantId: 'Participant ID',
  caregiverId: 'Caregiver ID',
  participants: 'Participants',
  participantValidationName: 'Name field cannot be empty',
  participantValidationValidName: 'Please enter a valid name',
  participantValidationEmail: 'Email field cannot be empty',
  participantValidationDateOfBirthFuture: 'Date of birth cannot be in the future',
  participantValidationDateOfBirthValid: 'Please enter a valid date of birth',
  participantValidationEmailInvalid: 'Invalid email address',
  participantValidationLocale: 'Please select a locale',
  participantValidationPhoneEmpty: 'Phone number field cannot be empty',
  participantValidationPhoneValid: 'Please enter a valid phone number',
  participantValidationSubjectId: 'Please enter a subject ID',
  participantValidationValidSubjectId: 'Please enter a valid subject ID',
  participantValidationTrack: 'Please assign the participant to a track',
  participantValidationVisitDatePast: 'Visit Date cannot be in the past',
  participantValidationVisitDateValid: 'Please enter a valid visit date',
  participantValidationVisitNameValid: 'Please select a visit name',
  password: 'Password',
  pleaseCheckErr: 'Please check errors before proceeding.',
  pleaseConfirmActualDate:
    'Please confirm the actual date this visit occurred on. If this visit did not happen, please mark “No, this visit was missed”.',
  pleaseConfirmUpcomingDate: 'Please confirm upcoming date.',
  pleaseNote: 'Please note',
  pleaseSelDifferentVisit: 'Please select a different visit',
  pleaseSelVisitFromEachArm: 'Please select at least one visit from each selected arm',
  preparing: 'Preparing',
  visitScheduleManagement: 'Visit Schedule Management',
  profileCreated: 'Profile Created',
  ptpAppSettings: 'Participant Settings',
  selectIdsHeading: 'Select the IDs you want to include in the study',
  networkConnectionReminder: 'Network Connection Reminder',
  ptpOfflineDurationDesc:
    'How many days of consecutive offline app usage before the participant is prompted to connect to the network? Network is necessary for the system to retrieve data collected during offline app usage.',
  ptpOfflineDurationInputPretext: 'Send network connection reminder after',
  ptpOfflineDurationInputPosttext: 'consecutive day(s) of offline app usage.',
  ptpContactInformationCollection: 'Participant Contact Information Collection',
  ptpNoVisitScheduleAssigned:
    'This participant does not have a visit schedule assigned yet. Please confirm when and which visit schedule the participant should complete next.',
  ptpNoVisitScheduleCreated:
    'No visit schedule is created yet for this study. These fields will be enabled after visit schedule is created.',
  ptpSubjectId: 'Participant Subject ID',
  questionErrorNoPdf: 'Please upload a consent',
  removeWindow: 'remove window',
  repeat: 'Repeat',
  review: 'Review',
  rewards: 'Rewards',
  rewardSelection: 'Reward Selection',
  saved: '...Saved!',
  saveVisit: 'Save Visit',
  saveVisitSchedule: 'Save Visit Schedule',
  saveArm: 'Save Arm',
  saving: 'Saving',
  searchEllipsis: 'Search...',
  security: 'Security',
  selectCollectionTypeWait: "Wait for Device Response <br />We'll pause here until we get data from your device.",
  selectCollectionTypeContinue: "Continue Anyway<br />You can move ahead, and we'll catch up with the device later.",
  selectDate: 'Select date',
  selectDateRange: "Please select date range acceptable for this question's answer.",
  selectDateTimeRange: "Please select date and time range acceptable for this question's answer.",
  selectPlaceholder: 'Select...',
  selectTime: 'Select time',
  selectTimeRange: "Please select time range acceptable for this question's answer.",
  selfSignUpCode:
    'Participants can use this Study Sign-up code or the Site Code to create their accounts through our self sign-up website.',
  sendTo: 'Send to',
  show: 'Show',
  showPtpSubjectId: ' Show participants their own subject ID',
  sites: 'Sites',
  specialRewards: 'Special Rewards',
  specificDate: 'Specific date',
  studies: 'Studies',
  studyConfigurations: 'Study Configurations',
  studyInfoViewOnly: 'Study Information (View Only)',
  studyName: 'Study Name',
  subjectId: 'The Subject ID is a string of numbers and/or letters that you can assign when adding a new participant',
  submitADcf: 'Submit a DCF',
  surveySelectDisplayCheckbox: 'Display checkbox or radio buttons with the answer choices.',
  surveyIntroDescription: 'Introduction text will be given in a speech bubble by Humi.',
  surveyIntroDisplayGreeting: 'Display greeting in introduction.',
  surveyReviewScreenTextToggle: 'Add Review/Reporting Screen Text',
  surveyReviewScreenTextPlaceholder: 'Type Review/Reporting Screen Text Here',
  surveyReviewScreenTextRequiredErr:
    'Review text cannot be blank when this question is required and review screen text is enabled.',
  integratedDeviceOnDemandQuestionTextToggle: 'Add Question Text for On-Demand Readings',
  integratedDeviceOnDemandQuestionTextPlaceholder: 'Type On-Demand Question Text Here',
  integratedDeviceOnDemandQuestionTextRequiredErr:
    'On-demand question text cannot be blank when this question is required and on-demand question text is enabled.',
  integratedDevicePrefilledQuestionTextToggle: 'Add Question Text for Pre-filled Readings',
  integratedDevicePrefilledQuestionTextPlaceholder: 'Type Pre-filled Question Text Here',
  integratedDevicePrefilledQuestionTextRequiredErr:
    'Pre-filled question text cannot be blank when this question is required and pre-filled question text is enabled.',
  surveyNRSOptOutPlaceholder: 'UI display answer',
  selectionRulesMaxTooltip: 'Ptp can select no more than this many options',
  selectionRulesMinTooltip: 'Ptp must select at least this many options',
  temporaryPassword: 'Temporary Password: ',
  temporaryPasswordCaption:
    'DCH does not deliver temporary password to the participant. Please connect with the participant offline to deliver the log in credentials.',
  temporaryPasswordCaptionForCaregiver:
    'DCH does not deliver temporary password to the caregiver. Please connect with the caregiver offline to deliver the log in credentials.',
  temporaryPasswordNote: 'Please note: Temporary password will expire in ',
  timedCompletion: 'Timed completion',
  timedEntryForPtpsToEdit: 'to complete incomplete diary entries after deployment.',
  timedEntryInfoTip:
    'Participants will only be allowed to edit incomplete instruments. Past instruments entries that are completed cannot be edited.',
  timedEntryPtpsAlwaysAllowed: 'Participants are always allowed to finish incomplete instruments entries.',
  timedEntryPtpsAlwaysAllowedSub: 'Always allowed to complete past instruments entries',
  timedEntryPtpsAlwaysAllowedSubSuffix: 'to complete past instruments entries',
  timedEntryForPtpsToEditDiary: 'to complete incomplete diary entries after deployment.',
  timedEntryInfoTipDiary:
    'Participants will only be allowed to edit incomplete diaries. Past diary entries that are completed cannot be edited.',
  timedEntryPtpsAlwaysAllowedDiary: 'Participants are always allowed to finish incomplete diary entries.',
  timedEntryPtpsAlwaysAllowedSubDiary: 'Always allowed to complete past diary entries',
  timedEntryPtpsAlwaysAllowedSubSuffixDiary: 'to complete past diary entries',
  timeoutWindowSub: 'Timeout window for the instrument in minutes',
  to: 'to',
  toneOfVoice: 'Tone of voice',
  toneOfVoiceBody: 'When a participant completes an instrument, what tone should the app respond with?',
  training: 'Training',
  trainingConfigBody:
    'Access curated DCH Admin Panel training materials anytime on your dashboard. These materials will be available for users before the study-go-live for optimal onboarding experience.',
  trainingDocuments: 'Training Documents',
  trainingDocumentThumbnail: 'Document Display Thumbnail (Optional)',
  trainingUploadSuccess: 'Training successfully uploaded',
  trainingVideos: 'Training Videos',
  trainingVideoThumbnail: 'Video Display Thumbnail (Optional)',
  triggerAnotherItem: 'Trigger another item',
  unordered: 'Unordered',
  unorderedInstrumentsBody: 'The participant will be able to choose which instrument to complete first',
  unorderedInstrumentsHeading: 'Unordered Instruments',
  uploadDocument: 'Upload Document',
  uploading: 'Uploading',
  uploadNewTrainingdocument: 'Upload New Training Document',
  uploadNewTrainingvideo: 'Upload New Training Video',
  uploadVideo: 'Upload Video',
  userName: 'User Name',
  users: 'Users',
  video: 'Video',
  videoName: 'Video Name',
  virtualVisitClinro: 'Virtual Visit (ClinRo)',
  virtualVisitConfigBody: 'Virtual visit allows ClinRo users to connect with participants through mobile devices.',
  virtualVisits: 'Virtual Visits',
  visibility: 'Visibility',
  visit: 'visit',
  visitAfterMissedPosttext: 'after a visit is marked “missed”',
  visitConfiguration: 'Visit Configuration',
  visitDayErr: 'Visit day cannot be empty',
  visitDayExceedsStudyDuration: 'Visit Day must fall within the {value} days study duration and cannot exceed it.',
  visitDayExceedsCycleDuration: 'Visit Day must fall within the {value} days cycle duration and cannot exceed it.',
  cycleDurationExceedsStudyDuration: 'Cycle duration must fall within the {value} days study duration and cannot exceed it.',
  visitCyclesSpanFullStudyDuration: 'The configured visit cycles already span the full study duration.',
  visitWindowErr: 'Visit window cannot be empty',
  visitDayNegErr: 'Visit day cannot be negative',
  visitDelFail: 'Visit failed to delete, please try again',
  armDelFail: 'Arm failed to delete, please try again',
  visitDelSuccess: 'Visit deleted successfully',
  armDelSuccess: 'Arm deleted successfully',
  visitDisplayName: 'Visit Display Name for Participant',
  visitDisplayNameInApp: 'Visit name displayed in App',
  visitItemConfirmQuestion: 'Should this item deploy when the visit’s status is <bold>not updated</bold>?',
  visitItemConfirmQuestionNo:
    'No, do not deploy this item unless the visit’s occurrence is confirmed by a coordinator.',
  visitItemConfirmQuestionTooltip:
    'When “No” is selected, this item will not deploy to the participant unless a study team member confirms the occurrence of the visit tied to this item. When “Yes” is selected, this item will deploy to the participant even without a study team member’s confirmation of the visit’s occurrence.',
  visitItemConfirmQuestionYes:
    'Yes, deploy this item even when the visit’s occurrence is not confirmed by a coordinator.',
  visitItemEngagement: 'Engagement item triggered by visit',
  visitItemEngagementBody:
    'An item may be deployed relative to a visit. An item deployed with this option is available in the Carousel along with other study instruments and expiration can be configured below. Participants will receive in-app gems or rewards for completing their engagement item.',
  visitItemMissedVisit: 'Missed visit follow-up',
  visitItemMissedVisitBody: `A missed visit follow-up is an item that will deploy when a coordinator indicates that a participant has missed a visit. A visit can be marked "missed" on the Visit Scheduling page or the Participant's detail drawer.`,
  visitItemVisitSummary: 'Visit summary',
  visitItemVisitSummaryBody: `A visit summary provides context about a participant's visit before or after the visit occurs. An item deployed with this option is persistently available under the "Visits" tab in the participant app, and only one Visit Summary may be created per visit. Participants will not receive in-app gems or rewards for reviewing a pre-visit summary.`,
  visitMissed: 'No, this visit was missed.',
  visitName: 'Visit Name',
  searchForVisitPlaceholder: 'Search for a visit…',
  searchForArmPlaceholder: 'Search for an arm...',
  armName: 'Arm Name',
  selectArmFirst: 'Please select an arm first',
  visitScreenName: 'Screening Visit',
  visitNameErr: 'Visit name cannot be empty',
  visitOccurred: 'Yes, this visit occurred.',
  visitHappenning: 'Is this visit happening?',
  visitConfirmedOnDay: 'The visit is confirmed for an upcoming date',
  visitOnDayOf: 'On the day of the visit',
  visitOnDayOfMissed: 'Immediately when a visit is marked “missed” by the coordinator.',
  visitSameDayConfirmation: 'Please click confirm if this is correct. Click cancel to make changes to visit schedule.',
  visitSameDayPrompt: 'There are more than one visit scheduled on a same day of the study.',
  visitSavedFail: 'Visit failed to save, please try again',
  visitSavedSuccess: 'Visit saved successfully',
  visitSchedule: 'Visit Schedule',
  visitScheduleVistNameQuestion: "What is the visit's name?",
  armNameQuestion: 'What is the study arm name?',
  visitScheduleJoinsStudy: 'joins study',
  visitScheduleLastVisit: 'last visit',
  visitScheduleStartsCycle: 'starts cycle',
  visitScheduleCompletesCycle: 'completes cycle...',
  visitScheduleCompletesCycleError: 'Specify the cycle',
  visitScheduleCompletesVisit: 'completes visit...',
  visitScheduleCompletesVisitError: 'Specify the visit',
  visitScheduleChangeVisitDate: 'Change visit date to',
  visitScheduleCreateNewAdhoc: 'Create new adhoc visit',
  visitScheduleCreateNewVisit: 'Create new visit',
  visitScheduleCreateNewVisitSchedule: 'Create new visit schedule',
  visitScheduleCreateArm: 'Create Arm',
  visitScheduleCurrentlyScheduledDate: 'Currently scheduled date',
  visitScheduleEditAdhoc: 'Edit adhoc visit',
  visitScheduleViewAdhoc: 'View adhoc visit',
  visitScheduleEditVisit: 'Edit visit',
  visitScheduleViewVisit: 'View visit',
  visitScheduleEditVisitSchedule: 'Edit visit schedule',
  visitScheduleViewVisitSchedule: 'View visit schedule',
  visitScheduleEditArm: 'Edit Arm',
  visitScheduleViewArm: 'View Arm',
  visitScheduleNoChange: 'No change',
  visitScheduleNoResultsPrevVisits: 'No Matching Schedule Previous Visits',
  visitScheduleProtocolDeviation:
    'This change would cause a protocol deviation. Please confirm to make this change or cancel this request to select another day.',
  visitSchedulePushNotificationNo:
    'Participant will receive a push notification about their updated visit schedule. Subsequent visits will not be affected by this change.',
  visitSchedulePushNotificationYes: 'Participant will receive a push notification about their updated visit schedule.',
  visitSchedulePushOut: 'Push out subsequent visits?',
  visitScheduleReschedule: 'Reschedule',
  visitScheduleViewInstruments: 'View Instruments',
  visitScheduleRescheduleAVisit: 'Reschedule a visit',
  visitScheduleSavedSuccess: 'Visit schedule saved successfully',
  armSavedSuccess: 'Arm saved successfully',
  visitScheduleSaveVisit: 'Save Visit',
  visitScheduleScheduleNewVisit: 'Schedule New Visit',
  visitScheduleSelectedDayTolerance: 'Selected day is outside of visit window tolerance',
  visitScheduleUpdateStatus: 'Update status',
  visitScheduleUpdatingHeading: 'Updating visit schedule?',
  visitScheduleUpdatingBody:
    'We will also reschedule the deployment of visit related instruments and visit summary according to this change.',
  visitScheduleVisitsInSchedule: 'Visits in selected visit schedule',
  visitScheduleVisitsInARM: 'Visits in selected ARM / WORKFLOW',
  visitScheduleWhenShould: 'When should this visit occur?',
  visitScheduleWhoWillBeReq: 'Who will be required to complete this visit?',
  visitSupport: 'Visit Support',
  visitSupportConfigBody:
    'Visit support helps to manage pre-visit materials such as visit reminders and participant engagement tools.',
  visitTimeVisibility: 'Record visit time during the appointment.',
  visitCycling: 'Visit Cycling',
  visitCyclingConfigBody: 'Visit cycling helps to manage visit materials such as visit arms, phases and cycles.',
  visitTemplateName: 'Visit Template Name',
  armName: 'Arm Name',
  visitWindowNegErr: 'Visit window cannot be negative',
  visitWindowInfo:
    'Scheduling a visit to another date would be within the protocol visit window. When rescheduling a visit outside of the approved Visit Schedule window may require a protocol deviation. Leaving the field empty will set the visit tolerance to 0 days.',
  visitWindow: 'visit tolerance window',
  whatTypeArticle: 'What type of deployment item is this?',
  whenAllComplete: 'When all complete',
  whenShouldDeployToPtp: 'When should this item <bold>deploy</bold> to the participant? ',
  whichVisitTrigger: "Which visit should trigger this instrument's deployment?",
  whichVisitExpire: 'Which visit should cause this instrument to expire?',
  unlessVisitConfirmationApplies: 'Unless a visit confirmation applies',
  yes: 'Yes',
  site: 'Site',
  reassignToLeafSite: 'Reassign the participant to a leaf site',
  selectSite: 'Select site...',
  selectLocale: 'Select locale...',
  selectSiteFirst: 'Please select site first',
  consent_builder_title: 'Consent Builder',
  consent_builder_description:
    "Consent Builder allows admins to draft a consent form on the admin portal. You'll have the ability to copy and paste content, format text, configure which signatures are needed, and add comprehension questions.",
  pdf_upload_title: 'PDF Upload',
  pdf_upload_description:
    'PDF Upload allows admins to upload the content of the consent form in PDF format. Please note PDF cannot be edited in any way once it is uploaded.',
  fileName: 'File name',
  previewPdfFile: 'Preview PDF File',
  pleaseConfirmAmountOfTime: 'Please confirm the amount of time to count for this question.',
  count: 'Count',
  minutes: 'minutes',
  seconds: 'seconds',
  timer_countdown: 'Count down from given time frame',
  timer_countdown_tooltip:
    'The timer will count up from zero by default. When this toggle is on, the timer will count down to zero',
  timer_audible_alert: 'Add audible alert when the timer ends',
  timer_disable_pause: 'Disable pause, resume',
  timer_disable_pause_tooltip:
    'Participants can pause and resume the timer by default. When this toggle is enabled, Participants will only have the option to reset the timer. ',
  addNewTrigger: 'Add new trigger',
  allInstrumentsOption: 'Deploy this instrument when <bold>all</bold> of the conditions are met',
  announcements: 'Announcements',
  atLeastOneInstrumentOption: 'Deploy this instrument when <bold>at least one</bold> of the conditions is met',
  completedSentToSystem: 'Completed, sent to system',
  consent: 'Consent',
  deployAllConditions: 'Deploy when all of the conditions are met.',
  deployAtLeastOneCondition: 'Deploy when at least one of the conditions is met.',
  diary: 'Diary',
  files: 'Files',
  instToInstHowLongAfter: 'How long after condition(s) completion?',
  instToInstTriggerError: 'Please select another instrument',
  noAnnouncementStatus: 'No announcement status details available',
  noDiarytatus: 'No diary status details available',
  noInstrumentStatus: 'No instrument status available',
  noInstrumentResponsesYet: 'No instrument responses yet',
  viewInstrumentResponses: 'View Instrument Responses',
  viewInstrumentStatus: 'View Instrument Status',
  opened: 'Opened',
  openedAndRead: 'Opened and read',
  optOut: 'Opt Out',
  optOutDescription: 'Allow participants to opt out of answering the question with a numeric value.',
  payments: 'Payments',
  receivedByDevice: 'Received by device',
  seen: 'Seen',
  sentToDevice: 'Sent to device',
  siteName: 'Site Name:',
  status: 'Status',
  caregiverId: 'Caregiver Id',
  statusTimestamp: 'Status Timestamp',
  statusTooltipContent: '“Status Timestamp” displays participant device local time when timestamp was collected.',
  systemReceived: 'System received',
  track: 'Track',
  trackManagement: 'Track Management',
  armManagement: 'Arm Management',
  visible: 'Visible',
  visits: 'Visits',
  instrumentWillDeployImmediately:
    'Note: instrument will deploy immediately if the selected time is earlier than the present time of the participant’s local time zone.',
  thisIdIsAvailable: 'This ID is available',
  thisIdIsTaken: 'This ID is already taken.',
  pleaseChooseAnother: 'Please choose another.',
  optional: 'Optional',
  test: 'TEST',
  submit: 'Submit',
  provideExampleImages: 'Provide example images',
  uploadImage: 'upload image',
  created: 'Created',
  study: 'study',
  filterApplied: 'filter applied',
  filtersApplied: 'filters applied',
  filterBy: 'filter by',
  filter: 'Filter',
  studyCapitalized: 'Study',
  clearAll: 'Clear all',
  apply: 'Apply',
  sortBy: 'Sort By:',
  studyCreateDate: 'Study Create Date',
  noResults: 'No Results',
  checkTheSpelling: 'Check the spelling or try a new search.',
  complete: 'Complete',
  awaitingPI: 'Awaiting PI',
  awaitingAdmin: 'Awaiting Admin',
  unopened: 'Unopened',
  declined: 'Declined',
  awaitingIw: 'Awaiting IW',
  awaitingAdditionalSignature: 'Awaiting additional signature',
  awaitingSignatureFromIw: 'Awaiting signature from impartial witness',
  awaitingSignatureFromPI: 'Awaiting signature from from investigator',
  invalidSigneeErr: 'Please select signee supported at the site receiving consent form.',
  invalidSigneePrompt: 'A configured signee is invalid, please either change the signee type or remove the signee.',
  requiredSigneeErr: 'At least one signee needs to be required to sign the consent form.',
  signatureItemDescription:
    'Select who will need to sign this signature box. You can reorder the signees and add additional signees as needed.',
  taskSaveErr: 'Could not save task to database',
  announcementSaveErr: 'Could not save announcement to database',
  displayMode: 'Display mode',
  carouselMode: 'Carousel mode',
  calendarMode: 'Calendar mode',
  carouselModeDescription:
    "Carousel Mode: Instrument is displayed in a rotating carousel format. For instrument featured on carousel, you'll find customizable UI properties to tailor the card's appearance to your liking.",
  calendarModeDescription:
    'Calendar Mode: This view integrates your instrument into calendar, allowing to track it based on specific dates and events. Instruments not displayed on the carousel are conveniently linked to buttons on both the map and calendar views.',
  participantInstrument: 'Participant Instrument',
  clinicianInstrument: 'Clinician Instrument',
  instrument: 'Instrument',
  article: 'Article',
  inReviewScreen: 'In-Review Screen',
  inReviewDescription: 'Display this question and participant response in review screen.',
  tmgGridRows: 'Grid Rows',
  tmgGridColumns: 'Grid Columns',
  tmgTimeLimit: 'Time Limit (seconds)',
  tmgTimeLimitMinErr: 'Minimum time limit is 1 second.',
  tmgTimeLimitMaxErr: 'Maximum time limit is 600 seconds.',
  tmgTimerDisplay: 'Timer Display',
  tmgRandomize: 'Randomize item order each administration',
  tmgRandomization: 'Randomization',
  tmgKeyMapping: 'Key Mapping',
  tmgInputType: 'Input Type',
  tmgSymbolKey: 'Symbol Key',
  tmgKeyPairsTitle: 'Key · 9 Pairs',
  tmgKeyPairsHint: 'Type a character or upload an image per slot. Digits are fixed 1–9.',
  tmgUploadSymbolsZip: 'Upload symbols zip',
  tmgReplaceSymbolsZip: 'Replace symbols zip',
  tmgUploadSymbolKey: 'Upload symbol key',
  tmgReplaceSymbolKey: 'Replace symbol key',
  tmgUploadSymbolKeyTitle: 'Upload symbol key',
  tmgUploadDialogSubtitle:
    'One ZIP of nine images, each named for the number it maps to: 1.svg … 9.svg.',
  tmgUploadSymbolKeySubtext:
    'Upload one ZIP of nine images, each named for the digit it maps to (1.svg … 9.svg or .png). SVG or transparent PNG must be square from 64×64px to 256×256px.',
  tmgKeyPreview: 'Key Preview',
  tmgKeyFormatNote:
    'SVG or PNG, square, min 64×64px to 256×256px, transparent background. Characters render in the participant’s font; images are safer for licensed instruments.',
  tmgUploadZipRestriction:
    'Exactly 1.svg–9.svg (or .png). SVG or transparent PNG must be square from 64×64px to 256×256px.',
  tmgKeyComplete: 'Key complete',
  tmgKeyIncompleteHint:
    'A ZIP missing a number, or containing an extra/unexpected file, is rejected as a whole rather than partially imported.',
  tmgPublishedKeyNote:
    'Existing published forms retain their current key until the question is explicitly re-published.',
  tmgUploadDialogFooterNote:
    'A ZIP missing a number, or holding an extra file, is rejected whole rather than partly imported. Existing forms keep their current key until you publish.',
  tmgSaveKey: 'Save key',
  tmgUploadingSymbols: 'Uploading symbols…',
  tmgUploadSymbolsFailed: 'There was a problem uploading the symbol images. Please try again.',
  tmgSymbolKeyRequiredErr: 'Please add symbol key before proceeding',
  tmgSymbolKeyCorruptedErr: 'Uploading symbols failed. Please re-upload.',
  tmgItemSequenceTitle: 'Item Sequence · Manual',
  tmgItemSequenceInstructions: 'Click a cell, then type 1–9. Arrow keys move, Backspace clears.',
  tmgEditItemSequence: 'Edit item sequence',
  tmgEditItemSequenceLocked: 'Upload the symbol key to enable manual item sequencing.',
  tmgSaveItemSequence: 'Save',
  tmgKeyReferenceTitle: 'Key',
  tmgProgressTitle: 'Progress',
  tmgBalanceCheckTitle: 'Balance check',
  tmgBalanceOver: 'over',
  tmgBalanceOverWarningLead: 'is used more frequently than the other options.',
  tmgBalanceOverWarningKeep: 'It’s fine to keep it as is.',
  tmgBalanceOverWarningTail:
    'Evenly distributing the options would simply make the task slightly harder to guess.',
  tmgClearAll: 'Clear all',
  tmgPressDigitToPlace: 'Press the digit to place its symbol',
  tmgGenerateForMe: 'Generate for me instead',
  tmgParticipantAnswerNote: 'Greyed lower boxes are participant answer fields and are never authored here.',
  tmgItemSequenceIncomplete: 'placed',
  tmgChangePairingHint:
    'To change a pairing, rename the files and upload again. SVG or transparent PNG must be square from 64×64px to 256×256px.',
  tmgInReviewDisabledNote: 'Off/Disabled',
  tmgPreviewDigitGuidance:
    'Enter the matching number (1–9). Cursor advances automatically. Next unlocks when all items are answered or the timer ends.',
  tmgPreviewCheckmarkGuidance:
    "Check the box only if the number is incorrect, leave it unchecked if it's correct. The user can manually navigate to the next item using the arrow keys.",
  tmgPreviewGridDimension: 'Grid Dimension',
  tmgPreviewTotalItems: 'Total Items',
  tmgPreviewTotalItemsDetail: '{rows} × {columns} ({total} total items)',
  tmgPreviewGridValue: '{rows} × {columns}',
  survey: 'Survey',
  saveResumeSubtitle: 'Save and resume',
  saveResumeQuestion:
    'Should participants be allowed to save their progress and resume within a configurable time frame?',
  saveResumeOption1: 'No, participants should not be able to save their progress and resume  ',
  saveResumeOption2: 'Yes, participant should be able to save their progress and resume within',
  allowReviewQuestion1: 'Should participants be allowed to review submitted entries within the app?',
  allowReviewOption1: 'Yes, participants can review past entries.',
  allowReviewOption2: 'No, participants should not review past entries.',
  allowReviewQuestion2: 'How many past entries should the participant see?',
  allowReviewAll: 'Show all entries',
  allowReviewPartial: 'Show entries from past',
  allowEditQuestion: 'Should participants be allowed to edit submitted entries within the app?',
  allowEditOption1: 'Yes, participant should be able to edit submitted entries for ',
  allowEditOption2: 'No, participants should not be able to edit submitted entries',
  pleaseConfigureVisualRepresentation: 'Please configure visual representation of food diary entry type',
  carbohydrates: 'Carbohydrates',
  fats: 'Fats',
  fiber: 'Fiber',
  proteins: 'Proteins',
  calories: 'Calories',
  alcohol: 'Alcohol Calories/Content',
  maximumPhotoLimit: 'Maximum Photo Limit',
  flagsmithConfiguration: 'Flagsmith Configuration',
  flags: 'Flags',
  studyConfig: 'Study Config',
  dataInbox: 'Data Inbox',
  noDataInbox: 'No data inbox document is uploaded at this time',
  requestId: 'Request ID:',
  reportType: 'Report Type:',
  participantIds: 'Participant IDs:',
  manualConsentLabel: 'This Patient has consented to use the Datacubed Health Patient Engagement App',
  setDeploymentTime: 'Set deployment time',
  studyVersionDetails: 'Study Version Details',
  versionChange: 'Version Change',
  versionChangeNotes: 'Version change notes (required)',
  promote: 'Promote',
  saveNotes: 'Save Notes',
  editStudyVersion: 'Edit Study Version',
  enterNewStudyVersion: 'Please enter new study version number.',
  studyVersionNumber: 'Study version number',
  confirm: 'Confirm',
  invalidVersionNumber:
    'Invalid version number. Use 0-9 digits, XX.XX format and ensure the new version is higher than the previous one.',
  doYouWantPromoteStudyToUat: 'Are you sure you want to promote this study? This cannot be undone.',
  doYouWantPromoteStudyToLive:
    'Are you sure you want to promote this study? This cannot be undone. The study cannot be further edited after promoting to Live.',
  arm: 'Arm',
  armNameTaken: 'Arm name is already taken',
  studyPromotion: 'Study Promotion',
  studyPromotionConfigBody: 'Study Promotion feature in your study',
  multiSchedule: 'Instrument Re-use (Multi-schedule)',
  multiScheduleConfigBody:
    'Allow instruments in this study to have multiple schedules. When disabled, instruments use a single schedule (legacy behavior).',
  multiScheduleApiOnlyNote: 'This setting can only be changed via the study configuration API.',
  multiScheduleStatusOn: 'On',
  multiScheduleStatusOff: 'Off',
  multiScheduleUploadNotAllowed:
    'This study does not allow multi-schedule instruments. Upload an instrument with a single schedule object, or enable Instrument Re-use on the study.',
  save: 'Save',
  ptpWillProgress: 'Participant will progress to this visit cycle next',
  ptpWillMove: 'Participant will move to the next cycle or visit.',
  ptpWillRepeat: 'Participant will repeat the current cycle.',
  ptpIsIn: 'Participant is in',
  visitCycle: 'Visit Cycle',
  zendesk: 'Zendesk-chat',
  zendeskChatConfigBody: 'Zendesk chat widget for user support',
  studyTimeline: 'Study Timeline',
}

export default STRINGS
